import React from 'react';
import { useNavigate, useLocation, Outlet } from 'react-router-dom';
import MainLayout from '../../components/MainLayout';
import { useTranslation } from '../../context/LanguageContext';
import ManagementHeader from '../management/ManagementHeader';
import '../management/management.css';
import './PlatformLayout.css';

/* 플랫폼 관리 (슈퍼어드민 전용) 공통 틀 — 공통 헤더 + 밑줄형 탭, 아래에 각 화면(Outlet).
 * 예전의 화면 안 좌측 메뉴는 사이드바와 같은 내용이라 탭으로 바꿨다. 스타일은 mg-(공통) + platform-(이 메뉴) */
const MENU = [
    { id: 'companies', labelKey: 'pages.platform.layout.menu.companies', icon: 'business', path: '/platform/companies' },
    { id: 'users', labelKey: 'pages.platform.layout.menu.users', icon: 'group', path: '/platform/users' },
    { id: 'status', labelKey: 'pages.platform.layout.menu.status', icon: 'monitoring', path: '/platform/status' },
    { id: 'licenses', labelKey: 'pages.platform.layout.menu.licenses', icon: 'license', path: '/platform/licenses' }
];

function PlatformLayout() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const active = MENU.find((m) => pathname === m.path || pathname.startsWith(`${m.path}/`)) || MENU[0];
    const isRegister = pathname === '/platform/companies/register';
    const crumbs = isRegister
        ? [{ label: t(active.labelKey), to: active.path }, { label: t('pages.platform.companyRegister.title') }]
        : [{ label: t(active.labelKey) }];

    return (
        <MainLayout>
            <div className="mg-page platform-container">
                <ManagementHeader
                    rootLabel={t('sidebar.platform.title')}
                    icon="admin_panel_settings"
                    crumbs={crumbs}
                    backTo={isRegister ? active.path : undefined}
                />
                <div className="mg-tabs" role="tablist">
                    {MENU.map((m) => (
                        <button
                            key={m.id}
                            type="button"
                            role="tab"
                            aria-selected={active.id === m.id}
                            className={`mg-tab ${active.id === m.id ? 'active' : ''}`}
                            onClick={() => navigate(m.path)}
                        >
                            <span className="material-symbols-outlined">{m.icon}</span>
                            {t(m.labelKey)}
                        </button>
                    ))}
                </div>
                <Outlet />
            </div>
        </MainLayout>
    );
}

export default PlatformLayout;
